import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Wrapper = styled.div`
  margin-top: 60px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr) ) ;
  grid-gap: 5px;
`;

const PieceWrapper = styled.div`
  position: relative;
  .name {
    opacity: 0;
    transition: opacity .2s;
  }
  &:hover {
    .name {
      opacity: 1;
      transition: opacity .2s;
    }
  }
  > a {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
`;
const Image = styled.img`
  width: 100%;
  opacity: 0;
  &.loaded {
    opacity: 1;
    transition: opacity .3s;
  }
`;
const Info = styled.div`
  position: absolute;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.85);
  text-align: center;
  padding: 50px;
  box-sizing: border-box;
`;
const Name = styled.div`
  font-size: 40px;
`;
const View = styled.div`
  font-size: 18px;
  margin-top: 40px;
`;

class PiecesList extends Component {
  onLoad = (e) => {
    // animates the image in for softer loading
    e.target.className += " loaded";
  }
  render() {
    const { pieces } = this.props;
    return (
      <Wrapper>
        { pieces.map((piece,i) =>
          <PieceWrapper key={i}>
            <Link to={`/piece/${piece.url}`}>
              <Image
                src={`../photos/${piece.url}/${piece.preview[0]}`}
                onLoad={this.onLoad}
              />
              <Info className="name">
                <Name>{piece.name}</Name>
                <View>— view —</View>
              </Info>
            </Link>
          </PieceWrapper>
        )}
      </Wrapper>
    );
  }
}

export default PiecesList;



// WEBPACK FOOTER //
// ./src/components/PiecesList.js